module.exports = __webpack_public_path__ + "img/wifi-2.07536e46.svg";